import Vue from "vue";

Vue.component('base-view', require('@/components/BaseView.vue').default)
